import { TIMEZONE_BY_LOCATION } from '../settings';

export function getTimezoneByRegionId(regionId: number) {
  return TIMEZONE_BY_LOCATION[regionId];
}
